import { render, staticRenderFns } from "./BreadcrumbRouter.vue?vue&type=template&id=0eff1a88&"
import script from "./BreadcrumbRouter.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports